export default __webpack_public_path__ + "static/media/gallery_01.09584e77.jpg";